import { StyleSheet } from 'aphrodite';
import constants from '../../../../constants/styles';

let {
  STATUS_PARENT_LABEL_COLOR,
  STATUS_PARENT_VALUE_COLOR,
  STATUS_PARENT_BG_COLOR,
  STATUS_PARENT_HOVER_BG_COLOR,
  TABLE_BG_COLOR,
  STATUS_RED_COLOR,
  STATUS_GREEN_COLOR,
  STATUS_YELLOW_COLOR,

  STATUS_PARENT_VALUE_COLOR_HEADER
} = constants;

let styles = {
  bases: {
    minWidth: 820,
    display: 'flex',
    backgroundColor: STATUS_PARENT_BG_COLOR,
    padding: '20px 30px 25px',
    borderRadius: 8,
    marginBottom: 10,
    position: 'relative',
    width: '95%',
    textTransform: 'uppercase'
  },

  base: {
    minWidth: 820,
    display: 'flex',
    backgroundColor: STATUS_PARENT_BG_COLOR,
    padding: '20px 30px 25px',
    borderRadius: 8,
    position: 'relative',
    borderBottom: `1px solid ${TABLE_BG_COLOR}`,
    width: '95%',
    textTransform: 'uppercase',
    ':hover': {
      backgroundColor: STATUS_PARENT_HOVER_BG_COLOR
    }
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    color: STATUS_PARENT_VALUE_COLOR,
    paddingLeft: 1,
    paddingRight: 0,
    position: 'relative',
    fontWeight: 'normal',
    fontSize: '15px',
    textTransform: 'uppercase'
  },
  fieldsHeader: {
    color: STATUS_PARENT_VALUE_COLOR_HEADER,
    display: 'flex',
    flexDirection: 'column',
    fontSize: '15px',
    paddingLeft: 1,
    paddingRight: 0,
    width: '23%',
    position: 'relative',
    fontWeight: 800
  },
  label: {
    fontSize: '0.7em',
    fontWeight: 'normal',
    textTransform: 'uppercase',
    color: STATUS_PARENT_LABEL_COLOR,
    marginBottom: 5,
    width: '100%'
  },
  green: {
    height: 10,
    width: 10,
    backgroundColor: STATUS_GREEN_COLOR,
    borderRadius: '50%'
  },
  red: {
    height: 10,
    width: 10,
    backgroundColor: STATUS_RED_COLOR,
    borderRadius: '50%'
  },
  yellow: {
    height: 10,
    width: 10,
    backgroundColor: STATUS_YELLOW_COLOR,
    borderRadius: '50%'
  },
  name: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  gateway: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '35%',
    paddingRight: 10
  },

  tagcount: {
    marginLeft: 10,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  lastSeen: {
    width: '35%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  light: {
    justifyContent: 'center',
    width: '10%',
    paddingLeft: 21
  },
  statusHeader: {
    width: '13%'
  },
  trash: {
    width: '10%',
    cursor: 'pointer'
  },
  notrash: {
    width: '10%'
  },
  referencePointsCount: {
    width: '14%'
  },
  tagsCount: {
    width: '15%',
    paddingLeft: 0
  },

  heading: {
    fontSize: 16,
    textTransform: 'uppercase',
    fontWeight: 500
  },
  macAddress: {
    paddingRight: 10,
    width: '25%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  macaddressHeader: {
    width: '25%',
    paddingRight: 10
  },
  gatewaynodeHeader: {
    width: '35%',
    paddingRight: 10
  },
  rpHeader: {
    width: '14%'
  },
  tagHeader: {
    width: '15%'
  },
  lastseenapHeader: {
    width: '35%'
  },
  noDataRow: {
    width: '95%'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/status/accesspoint/accessPointRow.styles.js